var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "#B4975A"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B4975A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.166 15.97h2.162V9.016H7.166v6.956zm2.233-8.889c0 .597-.441 1.08-1.167 1.08-.682 0-1.123-.483-1.123-1.08C7.109 6.469 7.564 6 8.26 6c.697 0 1.124.47 1.138 1.081zM10.621 11.234c0-.867-.028-1.593-.056-2.219h1.877l.1.968h.043c.284-.456.98-1.124 2.147-1.124 1.423 0 2.49.953 2.49 3v4.112h-2.163v-3.855c0-.896-.313-1.507-1.095-1.507-.597 0-.953.412-1.11.81-.056.142-.07.342-.07.54v4.012H10.62v-4.737z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.7843ec7cac6f1db22f37ee520d6057fc.svg";
export { ForwardRef as ReactComponent };